export const BLOCK_UNBLOCK_ADMIN_ACTION_TYPES = {
	BLOCK: 'BLOCK_USER',
	UNBLOCK: 'UNBLOCK_USER'
};

export const UPDATE_USER_FRAUD_STATUS_ADMIN_ACTION_TYPES = {
	MARK_USER_FRAUD: 'MARK_USER_FRAUD',
	UNMARK_USER_FRAUD: 'UNMARK_USER_FRAUD'
};

export const BLOCK_REASONS = {
	USER_REQUEST_NOT_INTERESTED: 'User Request, Not Interested',
	USER_REQUEST_PERSONAL_REASON: 'User Reques, Personal Reason',
	USER_REQUEST_TRUST_ISSUE: 'User Request, Trust Issue',
	USER_REQUEST_RNG_ISSUE: 'User Request, RNG Issue',
	USER_REQUEST_LOSING_GAMES: 'User Request, Losing Games',
	LIFE_THREAT: 'Life Threat',
	MEDIA_LEGAL_THREAT: 'Media or Legal Threat',
	MINOR_ACCOUNT: 'Minor Account',
	RESTRICTED_STATE: 'Restricted State',
	ACCOUNT_COMPROMISED: 'Account Compromised',
	CHARGEBACK_FRAUDULENT_TRANSACTION: 'ChargeBack or Fraudulent Transaction',
	MONEY_LAUNDERING: 'Money Laundering',
	RAF_FRAUD: 'RAF Fraud',
	SIGN_UP_BONUS_FRAUD: 'Signup Bonus Fraud',
	ACTIVE_WITH_ANOTHER_ACCOUNT: 'Active with another account',
	MULTIPLE_ACCOUNT_FRAUD: 'Multiple account fraud',
	PROBLEM_GAMER: 'Problem Gamer',
	OTHER: 'Other'
};

export const USER_LEVELS = {
	1: 1,
	2: 2,
	5: 5
};

export const MARK_FRAUD_OPTIONS = {
	YES: 'YES',
	NO: 'NO'
};
